export default function assetUrl(uri) {
    return __webpack_public_path__ + uri;
}